<script lang="ts" setup>
const props = defineProps<{
    color: 'sky-200' | 'green-300' | 'green-500',
    robuxes: number;
}>();
</script>
<template>
    <span v-if="robuxes > 0" class="flex gap-2.5 items-center">
        <span :class="`text-${color}`" class="font-sans text-[20px]">
            +{{ robuxes }} R$
        </span>
        <img
            :src="'/assets/icons/promocode-'+ props.color +'.svg'"
            alt="Promocode Icon" class="w-6 h-6" style="width: 24px; height: 24px;"/>
    </span>

</template>
